import { render, staticRenderFns } from "./case_data.vue?vue&type=template&id=ae74d0b2&scoped=true"
import script from "./case_data.vue?vue&type=script&lang=js"
export * from "./case_data.vue?vue&type=script&lang=js"
import style0 from "./case_data.vue?vue&type=style&index=0&id=ae74d0b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae74d0b2",
  null
  
)

export default component.exports